import React, { useEffect, useState } from 'react'
import { Skeleton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { get_event } from '../Redux/Action/EventAction';
import CreateEvent from './CreateEvent';
import CreateEventModal from '../Modal/CreateEventModal';
import EventdeleteModal from '../Modal/EventdeleteModal';
import EventeditModal from '../Modal/EventeditModal';
import { useTranslation } from 'react-i18next';
import EventModal from '../Modal/EventModal';
import EventqrModal from '../Modal/EventqrModal';
import useTitle from '../Hooks/useTitle';
import { useNavigate } from 'react-router-dom';
import EventCards from './EventCards';

const ViewEvents = () => {
    useTitle('Events');
    const { t } = useTranslation('view_event');
    const [Open, setOpen] = useState(false);
    const [displayModal, setDisplayModal] = useState(true);
    const [Opendel, setOpendel] = React.useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [Openedit, setOpenedit] = React.useState(false);
    const [selectedEvents, setSelectedevents] = useState(null);
    const dispatch = useDispatch();
    const { loading, viewevent } = useSelector((state) => state.Create)
    const [Openqr, setOpenqr] = useState(false);
    const [selectedEvent, setSelectedevent] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(get_event());
    }, [dispatch])

    const handleshowevent = () => {
        setOpen(!Open)
    }

    const handleshowqr = (items) => {
        setSelectedevent(items)
        setOpenqr(!Openqr)
    }

    const handleAddMedia = (eventItem) => {
        console.log('Add media for event:', eventItem);
        navigate("/MediaGallery", { state: { eventId: eventItem } });
    }

    const [anchorEl, setAnchorEl] = React.useState({});

    const handleClick = (event, eventId) => {
        if (!Openedit) {
            setAnchorEl((prevState) => ({
                ...prevState,
                [eventId]: event.currentTarget,
            }));
        }
    };

    const handleClose = (eventId) => {
        setAnchorEl((prevState) => {
            const newState = { ...prevState };
            delete newState[eventId];
            return newState;
        });
    };

    const handledelete = (eventId) => {
        setDeleteId(eventId);
        setOpendel(true);
        setAnchorEl({});
    }

    const handleedit = (event) => {
        setSelectedevents(event);
        setOpenedit(true)
        setAnchorEl({});
    }

    return (
        <>
            {viewevent && viewevent.data && viewevent.data.length > 0 ? (
                <div className="grid gap-4 p-8 py-6 mt-[76px] sm:ml-[300px]">
                    <div className="flex justify-between items-center z-[1] gap-2">
                        <span className='font-[600] text-[26px]'>{t("headre")}</span>
                        <button className='bg-[#3686FF] text-white rounded-lg w-full max-w-[160px] py-[12px] text-[14px]' onClick={handleshowevent}>
                            {t("btn_create")}
                        </button>
                    </div>
                    {loading ? (
                        <div className="w-full flex justify-items-between grid grid-cols-1 gap-9 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-3 shrink rounded-[20px] p-6">
                            {[1, 2, 3].map((items, i) => (
                                <div key={items} className="menuitem rounded-[20px] cursor-pointer w-full">
                                    <div className="div h-[350px] rounded-[20px]">
                                        <Skeleton variant="rectangular" width="100%" className="rounded-[20px]" height="100%" />
                                    </div>
                                    <div className="p-2">
                                        <Skeleton width="90%" height={20} />
                                    </div>
                                </div>
                            ))}
                        </div>
                    ) : (
                        <EventCards
                            viewevent={viewevent}
                            handleClick={handleClick}
                            handleClose={handleClose}
                            handleedit={handleedit}
                            handledelete={handledelete}
                            handleshowqr={handleshowqr}
                            handleAddMedia={handleAddMedia}
                            anchorEl={anchorEl}
                            t={t}
                        />
                    )}
                </div>
            ) : !loading && (
                <CreateEvent />
            )}
            <CreateEventModal
                Open={Open}
                setOpen={setOpen}
            />
            <EventdeleteModal
                Opendel={Opendel}
                setOpendel={setOpendel}
                deleteId={deleteId}
            />
            <EventeditModal
                Openedit={Openedit}
                setOpenedit={setOpenedit}
                event={selectedEvents}
            />
            <EventModal
                displayModal={displayModal}
                setDisplayModal={setDisplayModal}
            />
            {selectedEvent &&
                <EventqrModal
                    event={selectedEvent}
                    Openqr={Openqr}
                    setOpenqr={setOpenqr}
                />
            }
        </>
    )
}

export default ViewEvents